import React from "react";
import { Toolbar } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import UserProfile from "../UserProfile/UserProfile";
import Icon from "../Icon/Icon";
import { Icons } from "../../../utils/viewUtility";
import authService from "../../../utils/authService";
import { styles } from "../../../styles";
import PortalTypeMenu from "../PortalTypeMenu";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(styles);

const GlobalHeader = (props) => {
  const { portalList, portalType } = props;
  const history = useHistory();
  const classes = useStyles();
  const onHomeClick = () => {
    history.push("/");
  };

  return (
    <>
      <Toolbar className={classes.webLogo}>
        <Icon className={classes.brandLogo} pwaIcon iconType={Icons.HOME_LOGO} onClick={onHomeClick}/>
        {portalList && portalList.length  && portalType ? <span className={classes.branLogoSeparator}></span> : null}
        <PortalTypeMenu portalList={portalList} />
      </Toolbar>
      <div className={classes.grow} />
      <div className={classes.sectionDesktop} />
      {authService.isAuthenticated() ? <UserProfile /> : null}
    </>
  );
};

export default GlobalHeader;
